// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SpinnerIconButton_spinner__1jtsa"};